// extracted by mini-css-extract-plugin
export var noSpinners = "_nm-6";
export var percentageInput = "_nm-7";
export var variantColor1 = "_nm-0";
export var variantColor2 = "_nm-1";
export var variantColor3 = "_nm-2";
export var variantColor4 = "_nm-3";
export var variantColor5 = "_nm-4";
export var variantColor6 = "_nm-5";